export enum UserTypes {
    SAM = "SAM",
    EMA = "EMA"
}